import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ config: 'site/config' }),
        isHu() {
            return this.config.country === 'hu'
        },
        privacy() {
            return `${this.config.main_page}${
                this.isHu ? 'adatkezelesi-tajekoztato' : 'privacy-policy'
            }`
        },
        terms() {
            return `${this.config.main_page}${this.isHu ? 'aszf' : 'terms-of-use'}`
        },
    },
}
